// import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

import PropTypesGql from '@/extensions/shop/store/graphql/queries/PropTypes.gql';

export default {
    fetchList: () =>
        new Promise((resolve, reject) => {
            let variables = {};

            apolloClient
                .query({
                    query: PropTypesGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_PropTypes))
                .catch(err => reject(err));
        })
    // fetchPropTypesPaginated: data => new Promise((resolve, reject) => {

    //     let filters = []
    //     _.each(data.filters, entry => filters.push(entry))

    //     apolloClient.query({
    //         query: PropTypesPaginatedGql,
    //         variables: {
    //             currentPage: _.get(data, 'pageInfo.currentPage', 1),
    //             perPage: _.get(data, 'pageInfo.perPage', 25),
    //             order: _.get(data, 'variables.order', 'id'),
    //             direction: _.get(data, 'variables.direction', 'asc'),
    //             filters,
    //         }
    //     })
    //         .then(({data}) => resolve(data))
    //         .catch(err => reject(err))
    // }),
    // fetchPropType: id => {
    //     if (id === undefined) throw new Error('required argument is missing')

    //     return new Promise((resolve, reject) => {
    //         apolloClient.query({
    //             query: PropTypeGql,
    //             variables: { id }
    //         })
    //             .then(({data}) => resolve(data.CO_PropType))
    //             .catch(err => reject(err))
    //     })
    // },
    // create: propType => {
    //     if (propType === undefined) throw new Error('required argument is missing')

    //     propType = _.removeDeepByKey(propType, '__typename')
    //     return new Promise((resolve, reject) => {
    //         apolloClient.mutate({
    //             mutation: CreatePropTypeGql,
    //             variables: { propType }
    //         })
    //             .then(({data}) => {
    //                 apolloClient.clearStore()
    //                 resolve(data.CO_CreatePropType)
    //             })
    //             .catch(err => reject(err))
    //     })
    // },
    // update: propType => {
    //     if (propType === undefined) throw new Error('required argument is missing')

    //     propType = _.removeDeepByKey(propType, '__typename')
    //     return new Promise((resolve, reject) => {
    //         apolloClient.mutate({
    //             mutation: UpdatePropTypeGql,
    //             variables: { propType }
    //         })
    //             .then(({data}) => {
    //                 apolloClient.clearStore()
    //                 resolve(data.CO_UpdatePropType)
    //             })
    //             .catch(err => reject(err))
    //     })
    // },
    // delete: id => {
    //     if (id === undefined) throw new Error('required argument is missing')

    //     return new Promise((resolve, reject) => {
    //         apolloClient.mutate({
    //             mutation: DeletePropTypeGql,
    //             variables: { id }
    //         })
    //             .then(({data}) => {
    //                 apolloClient.clearStore()
    //                 resolve(data.CO_DeletePropType)
    //             })
    //             .catch(err => reject(err))
    //     })
    // }
};
